import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Typography, CircularProgress, Avatar
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function ProfileDialog({ open, phoneNumber, onClose }) {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (!open || !phoneNumber) return;
    setLoading(true);
    supabase
      .from('Profiles')
      .select('*')
      .eq('phone_number', phoneNumber)
      .single()
      .then(({ data, error }) => {
        if (error) console.error(error);
        else setProfile(data);
      })
      .finally(() => setLoading(false));
  }, [open, phoneNumber]);

  const getImageUrl = fn =>
    fn ? supabase.storage.from('profile-images').getPublicUrl(`profiles/${fn}`).data.publicUrl : null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {profile?.user_type === 'Stylist' ? 'Stylist Profile' : 'Client Profile'}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ textAlign:'center', p:4 }}><CircularProgress/></Box>
        ) : profile ? (
          <Box>
            {profile.profile_image && (
              <Box sx={{ display:'flex', justifyContent:'center', mb:2 }}>
                <Avatar
                  src={getImageUrl(profile.profile_image)}
                  sx={{ width:80, height:80 }}
                />
              </Box>
            )}
            <Typography><strong>Name:</strong> {profile.first_name} {profile.last_name}</Typography>
            <Typography><strong>Email:</strong> {profile.email}</Typography>
            <Typography><strong>Phone:</strong> {profile.phone_number}</Typography>
          </Box>
        ) : (
          <Typography>No profile found.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {profile && (
          <Button
            variant="contained"
            onClick={() => {
              onClose();
             nav(`/dashboard/profile/${profile.id}`);
            }}
          >
            View More
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
